module.exports = __webpack_public_path__ + "static/media/logo.4b730fd6.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.svg
 ** module id = 461
 ** module chunks = 0
 **/